import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const ReadyCase = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 16"
      {...rest}
      fill={fill}
    >
      <path d="M4.119.667a.621.621 0 0 0-.621.621v13.424c0 .343.278.621.621.621h7.762a.621.621 0 0 0 .621-.621V1.288a.621.621 0 0 0-.621-.621H4.119zm-1.288.621C2.831.577 3.408 0 4.119 0h7.762c.711 0 1.288.577 1.288 1.288v13.424c0 .711-.577 1.288-1.288 1.288H4.119a1.288 1.288 0 0 1-1.288-1.288V1.288z" />
      <path d="M2.875 8.598a.334.334 0 0 1 .455-.124l1.781 1.018c.104.059.168.17.168.289v5.885a.333.333 0 1 1-.666 0V9.974l-1.614-.922a.334.334 0 0 1-.124-.455zm10.25 0a.334.334 0 0 1-.124.455l-1.614.922v5.692a.333.333 0 1 1-.666 0V9.782c0-.12.064-.23.168-.289l1.781-1.018a.334.334 0 0 1 .455.124zM8 9.861a.685.685 0 1 0 0 1.37.685.685 0 0 0 0-1.37zm-1.351.684a1.351 1.351 0 1 1 2.702 0 1.351 1.351 0 0 1-2.702 0zM4.867 2.401c0-.184.149-.333.333-.333h5.599c.184 0 .333.149.333.333v2.036a.333.333 0 0 1-.333.333H5.2a.333.333 0 0 1-.333-.333V2.401zm.667.333v1.369h4.932V2.734H5.534zm-.667 3.739c0-.184.149-.333.333-.333h5.599a.333.333 0 1 1 0 .666H5.2a.333.333 0 0 1-.333-.333z" />
    </svg>
  );
};

ReadyCase.category = 'product-category';

ReadyCase.displayName = 'ReadyCase';
